import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Toast } from "../shared/Toast";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Pagination, Navigation } from "swiper";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import detectLanguage from "./promotedPreviewStyles";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function PromotedGalleryPreview({ preview, edit }) {
  const [description, setDescription] = useState("");
  const handleClick = () => {
    let url = preview.button_link;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    window.open(url, '_blank');
  };
  const handleClickUrl = () => {
    if (preview.click_url !== null && preview.click_url !== undefined && preview.click_url !== '') {
      let url = preview.click_url
      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }
      window.open(url, '_blank');
    }
    else {
      Toast('error', "There is nothing to show")
    }
  }
  if (edit === true) {
    preview.img_urls = preview.gallery;
  }

  useEffect(() => {
    setDescription(prevDescription => {
      let newDescription = preview.description || "";
      if (newDescription?.search("<<>>") !== -1) {
        let text = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        text_inside = String(text_inside);
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text?.length) {
          newDescription = newDescription.replace(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${text_inside}</span>`);
        }
        let newtext = newDescription.match(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        let linktext = newDescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        const originalString = String(linktext);
        const modifiedString = originalString.substring(2, originalString.length - 4);
        console.log(linktext, originalString, modifiedString, newtext)
        if (newtext?.length) {
          newDescription = newDescription.replace(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${modifiedString}</span>`);
        }
        let phone_text = newDescription.match(
          /(?<=<<(0\d{10}|[6-9]\d{9})>>)[a-zA-Z0-9-!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (phone_text) {
          for (let i of phone_text) {
            newDescription = newDescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9-!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
        let subText = newDescription.match(
          /(?<=<<12>>)[a-zA-Z0-9!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (subText) {
          for (let i of subText) {
            newDescription = newDescription.replace(
              /<<(12)>>[a-zA-Z0-9!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
      }
      return newDescription;
    });
    const handleClickOnSpan = (event) => {
      const target = event.target;
      if (target.tagName.toLowerCase() === "span" && target.classList.contains("hover:cursor-pointer")) {
        const url = preview.click_url;
        if (url) {
          handleClickUrl();
        }
      }
    };

    document.addEventListener("click", handleClickOnSpan);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOnSpan);
    };
  }, [preview.description]);
  const { heading, descrip } = detectLanguage(preview.head_line)

  return (
    <>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-promoted-gallery !h-[90%]">
          <div className="!h-[40%]">
            <Swiper
              spaceBetween={50}
              pagination={true}
              navigation={true}
              modules={[Navigation, Pagination]}
              className="mySwiper !h-[100%]"
            >
              {edit === true
                ? preview.img_urls
                  ? preview.img_urls.map((imgLink, index) => {
                    return <SwiperSlide><img key={index} src={imgLink.image} alt="" className="w-full h-full" /></SwiperSlide>;
                  })
                  : null
                : preview.img_urls.map((imgLink, index) => {
                  return <SwiperSlide><img key={index} src={imgLink} className="w-full h-full" alt="" /></SwiperSlide>;
                })}
            </Swiper>
          </div>
          <div className="p-2">
            <h6 className="hover:cursor-pointer" onClick={handleClickUrl} style={heading}>{preview.head_line}</h6>
            <div dangerouslySetInnerHTML={{ __html: description }} style={descrip}></div>
            <div>
              {preview.button_enabled ? (preview.btn_text_bgclr !== "#ffffff" ? <div className="d-flex justify-content-center"><button className="btn" style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr, border: `1px solid ${preview.btn_text_clr} ` }} onClick={handleClick}>{preview.button_text}</button></div>
                : <div className="d-flex justify-content-center"> <button onClick={handleClick}>{preview.button_text}</button></div>) : null}
              {/* style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr }} */}
            </div>
          </div>
        </div>
        <span className="text-xs mb-2 px-2 text-gray-400 flex items-center"><SlIcon library="lucide" name="megaphone"></SlIcon>&nbsp;Sponsored story</span>
        <hr className="!m-0"></hr>
      </div>
    </>
  );
}

export default PromotedGalleryPreview;
